import { Injectable } from '@angular/core';
import { AccessPermissions, CanDo, IClaimSubAccess, User } from './me.lib';
import { BehaviorSubject } from 'rxjs';
import { AuthTokenService } from './auth-token.service';
import { LoggerService } from '../shared/logger.service';

@Injectable({
  providedIn: 'root'
})
export class MeService {

  availablePermissions: AccessPermissions = new AccessPermissions(); //

  //#region Private properties

  private _cachedToken = new BehaviorSubject<string | null>(null);

  //#endregion

  constructor(
    private logger: LoggerService,
    private authTokenService: AuthTokenService
  ) { }

  get(): User | null {
    return this.authTokenService.getClaims();
  }

  get userId(): number | undefined {
    return this.get()?.userId;
  }

  get email(): string | undefined {
    return this.get()?.email;
  }

  isLoggedIn(): boolean {
    return this.authTokenService.loggedIn;
  }

  hasPermission(permission: CanDo, accessClaims?: IClaimSubAccess): boolean {
    // this.logger.debug(`hasPermissions:`, permission, accessClaims);
    if (this.authTokenService.loggedIn) {
      let { entity, action } = permission;
      // let access = this.authTokenService.getAccessClaims();
      if (!accessClaims) {
        return false;
      }
      let myPermission = accessClaims.permissions.filter(p => p.entity == entity)[0];
      // this.logger.debug(`hasPermission:myPermission: `, myPermission);
      if (!myPermission) {
        return false;
      }
      for (let a of myPermission.actions) {
        if (a === action) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  };


  allICanDo(entityParam: string): any {
    this.logger.debug(`allICanDo:entityParam: `, entityParam);
    let permission = this.availablePermissions.accessPermission(entityParam);
    if (!permission) {
      return undefined;
    }
    // this.logger.debug(`allICanDo:permission: `, permission);
    let { entity } = permission;
    interface IObj {
      [key: string]: boolean
    };
    let returnObj: IObj = {};

    let accessClaims = this.authTokenService.getAccessClaims();
    // this.logger.debug(`allICanDo:accessClaims: `, accessClaims);
    for (let prop of permission.actions) {
      returnObj[`can_${prop}`] = this.hasPermission(new CanDo(entity, prop), accessClaims);
    }
    return returnObj;
  };

}
